import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useAssetsApi() {
  const callApi = useApiCall();

  const getAssetsList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSETS_LIST, data, onSuccess, onError);
  };
  const getAssetNameByParam = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_NAME_BY_PARAM, data, onSuccess, onError);
  };

  const getAssetCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_CODE, data, onSuccess, onError);
  };
  const getAssetCategpry = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_CATEGORY, data, onSuccess, onError);
  };
  const getAssetdepartment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_DEPARTMENT, data, onSuccess, onError);
  };

  const getAssetGrouplist = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_GROUPLIST, data, onSuccess, onError);
  }
  const getAssetSubGrouplist = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_SUBGROUPLIST, data, onSuccess, onError);
  }
  const GetAssetTypeList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_TYPE_LIST, data, onSuccess, onError);
  }

  const GetAssetClassificationList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_CLASIFICATION_LIST, data, onSuccess, onError);
  }


  const GetAssetStatusList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_STATUS_LIST, data, onSuccess, onError);
  }


  const GetvenderList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_VENDOR_LIST, data, onSuccess, onError);
  }

  const saveAssets = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.SAVE_ASSETS, data, onSuccess, onError);
  }
  const deleteAsset = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.DELETE_ASSETS, data, onSuccess, onError);
  }
  const updateStatus = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.UPDATE_STATUS, data, onSuccess, onError);
  }


  const GetnoteList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.NOTE_LIST, data, onSuccess, onError);
  }

  const saveNotes = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.NOTE_SAVE, data, onSuccess, onError);
  }
  const deleteNotes = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.DELETE_NOTES, data, onSuccess, onError);
  }


  const GetAttachmentList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_ATTACHMENT, data, onSuccess, onError);
  }

  const SaveAssetAttachment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.SAVE_ASSET_ATTACHMENT, data, onSuccess, onError);
  }
  const SaveAssetImage = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.SAVE_ASSET_IMAGE, data, onSuccess, onError);
  }


  const DeleteAssetAttachment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.DELETE_ASSET_ATTACHMENT, data, onSuccess, onError);
  }

  const Exportcsv = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.EXPORT_TO_CSV, data, onSuccess, onError);
  }
  const Exportpdf = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.EXPORT_TO_PDF, data, onSuccess, onError);
  }
  const ExportQrCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.EXPORT_QR_CODE, data, onSuccess, onError);
  }
  const ExportQrCodePng = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.EXPORT_QR_CODEPNG, data, onSuccess, onError);
  }

  const GetWarrantyList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_WARRANTY_LIST, data, onSuccess, onError);
  }

  const SaveAssetWarrantyAttachment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.SAVE_ASSET_WARRANTY_ATTACHMENT, data, onSuccess, onError);
  }
  const WarrantyExportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.WARRANTY_EXPORT_TO_XLS, data, onSuccess, onError);
  }

  const GetAssetWarrantyAttachments = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_WARRANTY_ATTACHMENTS, data, onSuccess, onError);
  }

  const SaveAssetWarranty = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.SAVE_ASSET_WARRANTY, data, onSuccess, onError);
  }

  const SaveAssetDetails = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.SAVE_ASSET_DETAILS, data, onSuccess, onError);
  }

  const GetWarrantyTermList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_WARRANTY_TERM_LIST, data, onSuccess, onError);
  }
  const GetJournalEntryByAssetId = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_JOURNAL_ENTRY_BY_ASSET_ID, data, onSuccess, onError);
  }



  const MoveAsset = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.MOVE_ASSET, data, onSuccess, onError);
  }
  const GetAssetDetailsList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_DETAILS_LIST, data, onSuccess, onError);
  }
  const GetAssetStatusLog = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_STATUS_LOG, data, onSuccess, onError);
  }

  const DeleteAssetDetails = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.DELETE_ASSET_DETAILS, data, onSuccess, onError);
  }

  const GetAssetMovementLogList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_MOVEMENT_LOG_LIST, data, onSuccess, onError);
  }
  const ExportAssetReportcsv = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.EXPORT_ASSET_REPORT_CSV, data, onSuccess, onError);
  }
  const getAssetsReportList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSETS_REPORT_LIST, data, onSuccess, onError);
  };

  const convertToOwnedAsset = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.CONVERT_TO_OWNED_ASSET, data, onSuccess, onError);
  };

  const GetWorkOrderUsedSpareParts = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_WORKORDER_USED_SPARE_PARTS, data, onSuccess, onError);
  };

  const getSparePartsUsageReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_SPARE_PARTS_USAGE_REPORT, data, onSuccess, onError);
  };

  const getMttrReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_MTTR_REPORT, data, onSuccess, onError);
  };

  const getMttrReportFilters = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_MTTR_REPORT_FILTERS, {}, onSuccess, onError);
  };

  const getMtbfReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_MTBF_REPORT, data, onSuccess, onError);
  };

  const exportSparePartsUsageReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.EXPORT_SPARE_PARTS_USAGE_REPORT_XLS, data, onSuccess, onError);
  };

  const exportMttrReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.EXPORT_MTTR_REPORT_XLS, data, onSuccess, onError);
  };

  const exportMtbfReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.EXPORT_MTBF_REPORT_XLS, data, onSuccess, onError);
  };

  return {
    getAssetsList,
    getAssetCode,
    getAssetCategpry,
    getAssetdepartment,
    getAssetGrouplist,
    getAssetSubGrouplist,
    GetAssetTypeList,
    GetAssetClassificationList,
    GetAssetStatusList,
    GetvenderList,
    saveAssets,
    deleteAsset,
    GetnoteList,
    saveNotes,
    deleteNotes,
    updateStatus,
    GetAttachmentList,
    SaveAssetAttachment,
    DeleteAssetAttachment,

    Exportcsv,
    Exportpdf,
    ExportQrCode,
    SaveAssetImage,
    GetWarrantyList,
    SaveAssetWarrantyAttachment,
    WarrantyExportToXLS,
    GetAssetWarrantyAttachments,
    SaveAssetWarranty,
    SaveAssetDetails,
    GetWarrantyTermList,
    MoveAsset,
    GetAssetDetailsList,

    GetJournalEntryByAssetId,
    ExportQrCodePng,


    GetAssetStatusLog,
    DeleteAssetDetails,
    GetAssetMovementLogList,
    getAssetNameByParam,
    ExportAssetReportcsv,
    getAssetsReportList,
    convertToOwnedAsset,
    GetWorkOrderUsedSpareParts,
    getSparePartsUsageReport,
    getMttrReport,
    getMttrReportFilters,
    getMtbfReport,
    exportSparePartsUsageReportToXLS,
    exportMttrReportToXLS,
    exportMtbfReportToXLS,
  };
}
